import axios from 'axios';
import { ResponsiveEmbed } from 'react-bootstrap';
import { call, put, select } from 'redux-saga/effects';
import { API } from '../constants/api';
import { methods } from '../constants/constants';
import { actions } from '../reducers/academies';
import { actions as usuariosActions } from '../reducers/usuarios';
import { sagaNames, handleSagaError } from './index';


// Gets academiesAlreadyFetched
export const academiesFromStore = state => state.academies.academies;
export const plataformasFromStore = state => state.academies.plataformas;
export const academyDeleteImpactFromStore = (state, idAcademia) => state.academies.academiesDeleteImpactById?.[idAcademia];

function fetchPlataformas() {
    //debugger;
    return axios({
        method: methods.GET,
        url: API.ACADEMIES.GET_LIST_PLATAFORMAS,
    });
}

function fetchAcademies() {
	return axios({
		method: methods.GET,
		url: API.ACADEMIES.GET_LIST_ACADEMIES,
	});
}

function fetchAcademyDeleteImpact(idAcademia) {
  return axios({
    method: methods.GET,
    url: API.ACADEMIES.GET_DELETE_IMPACT,
    params: {
      id: idAcademia,
    },
  });
}

function postAcademiesData(academie) {
	return axios({
		method: methods.POST,
		url: API.ACADEMIES.GET_LIST_ACADEMIES,
    data: {
      nombre: academie.nombre,
      plataforma: academie.plataforma,
      publica: academie.publica
    },
	});
}

function putAcademiesData(academie) {
	return axios({
		method: methods.PUT,
		url: API.ACADEMIES.GET_LIST_ACADEMIES,
    data: {
      id: academie.id,
      nombre: academie.nombre,
      plataforma: academie.plataforma,
      publica: academie.publica
    },
	});
}

function deleteAcademiesData(academie) {
	return axios({
		method: methods.DELETE,
        url: API.ACADEMIES.GET_LIST_ACADEMIES,
        data: {
            id: academie.id,
            nombre: academie.nombre,
            plataforma: academie.plataforma,
      publica: academie.publica,
      eliminarUsuariosAsociados: Boolean(academie.eliminarUsuariosAsociados)
        }
	});
}

export function* getPlataformas() {
    //debugger;
    try {
        const plataformasStore = yield select(plataformasFromStore);
        let plataformas = null;
        if (!plataformasStore || (Array.isArray(plataformasStore) && plataformasStore.length === 0)) {
            const response = yield call(fetchPlataformas);
            plataformas = response && response.data;
        } else {
            plataformas = plataformasStore;
        }
        yield put(actions.successGetPlataformas(plataformas));
    } catch (error) {
        const reducerFailureAction = actions.errorGetPlataformas(error);
        yield handleSagaError(sagaNames.GET_PLATAFORMAS, error, reducerFailureAction);
    }
}

export function* getAcademies() {
  try {
    const academiesStore = yield select(academiesFromStore);
    let academies = null;
    if (!academiesStore || (Array.isArray(academiesStore) && academiesStore.length === 0)) {
      const response = yield call(fetchAcademies);
      /* REGULAR BEHAVIOUR ENDS */
      // academies = normalizeAcademies(response);
      academies = response && response.data;
    } else {
      academies = academiesStore;
    }
    yield put(actions.successGetAcademies(academies));
  } catch (error) {
    const reducerFailureAction = actions.errorGetAcademies(error);
    yield handleSagaError(sagaNames.GET_ACADEMIES, error, reducerFailureAction);
  }
}

export function* postAcademies(args) {
    try {
    const response = yield call(postAcademiesData, args.academie);
    // const status = response && response.status;
    yield put(actions.successPostAcademies(response));
  } catch (error) {
    const reducerFailureAction = actions.errorPostAcademies(error);
    yield handleSagaError(sagaNames.POST_ACADEMIES, error, reducerFailureAction);
  }
}

export function* editAcademies(args) {
  try {
    const response = yield call(putAcademiesData, args.academie);
    // const status = response && response.status;
    yield put(actions.successEditAcademies(response));
  } catch (error) {
    const reducerFailureAction = actions.errorEditAcademies(error);
    yield handleSagaError(sagaNames.EDIT_ACADEMIES, error, reducerFailureAction);
  }
}

export function* deleteAcademies(args) {
  try {
    const response = yield call(deleteAcademiesData, args.academie);
    // const status = response && response.status;
    yield put(actions.successDeleteAcademies(response));
    yield put(usuariosActions.getUsuarios(true));
  } catch (error) {
    const reducerFailureAction = actions.errorDeleteAcademies(error);
    yield handleSagaError(sagaNames.DELETE_ACADEMIES, error, reducerFailureAction);
  }
}

export function* getAcademyDeleteImpact(args) {
  try {
    const idAcademia = args.idAcademia;
    const impactStore = yield select(academyDeleteImpactFromStore, idAcademia);
    let impact = impactStore;

    if (args.force || !impactStore) {
      const response = yield call(fetchAcademyDeleteImpact, idAcademia);
      impact = response && response.data;
    }

    yield put(actions.successGetAcademyDeleteImpact(idAcademia, impact));
  } catch (error) {
    const reducerFailureAction = actions.errorGetAcademyDeleteImpact(args.idAcademia, error);
    yield handleSagaError(sagaNames.GET_ACADEMY_DELETE_IMPACT, error, reducerFailureAction);
  }
}
